module.exports = __webpack_public_path__ + "static/media/video-placeholder-blue.428aa803.svg";